import React from "react";

export default function Math() {
  return (
    <div>
      <h1>Math</h1>
      <p>This is the Math component.</p>
    </div>
  );
}
